/**
 * Maps a SharePoint "Certified For" category (from the Certified Standard Work
 * Trainers list export) to the matching WorkdayCertification NAME.
 *
 * Names are used rather than ids so the map is environment-agnostic — the import
 * resolves each name to the current environment's cert id from the fetched
 * WorkdayCertification list at runtime.
 *
 * Every category in the export is mapped: business approved all 21 rows on
 * 2026-07-29 (story 119694, "Cert Mapping Review Response.xlsx"), including the
 * five that had no confident match and the BESS -> Storage cert renames.
 *
 * "Substation" is a flat map to the Solar & Storage cert: the SharePoint list has
 * a single "Substation" category, and all unexpired rows under it are Solar. A
 * separate Wind Substation cert is planned but does not exist yet — since this is
 * a one-time import, the flat map is intentional.
 */
export const STANDARD_WORK_TRAINER_CERT_BY_CATEGORY: Readonly<Record<string, string>> = {
    'WTG Civil': 'WTG Civil Cert. Standard Work Trainer',
    'WTG Install - GE': 'WTG Install - GE Cert. Standard Work Trainer',
    'WTG Install - Vestas': 'WTG Install - Vestas Cert. Standard Work Trainer',
    'WTG Install - Siemens': 'WTG Install - Siemens Cert. Standard Work Trainer',
    'WTG Install - Nordex': 'WTG Install - Nordex Cert. Standard Work Trainer',
    'WTG Install - SGRE': 'WTG Install - SGRE Cert. Standard Work Trainer',
    'WTG Foundations': 'Spread Footing Foundation Cert. Standard Work Trainer',
    'Collections': 'WTG Collections Cert. Standard Work Trainer',
    'Substation': 'Solar & Storage Substation Cert. Standard Work Trainer',
    'Solar Civil': 'Solar Civil Cert. Standard Work Trainer',
    'Solar Install (ATI)': 'Solar Install - ATI Cert. Standard Work Trainer',
    'Solar Install (NEXTracker & NEXTracker XTR)': 'Solar Install - NEXTracker Cert. Standard Work Trainer',
    'Solar Install (GameChange)': 'Solar Install - GameChange Cert. Standard Work Trainer',
    'Solar Electrical': 'Solar Electrical Cert. Standard Work Trainer',
    'Solar Electrical Testing': 'Solar Electrical Testing & Commissioning Cert. Standard Work Trainer',
    'Wind Electrical Testing': 'Wind Electrical Testing & Commissioning Cert. Standard Work Trainer',
    'GE Repower': 'GE Repower Cert. Standard Work Trainer',
    'Siemens Repower': 'Siemens Repower Cert. Standard Work Trainer',
    'BESS Civil': 'Storage Civil Cert. Standard Work Trainer',
    'BESS Foundations': 'Storage Foundations Cert. Standard Work Trainer',
    'BESS Install': 'Storage Install Cert. Standard Work Trainer',
    'BESS Electrical': 'Storage Electrical Cert. Standard Work Trainer',
};
